import axios from '@/plugins/axios';
import apiUrls from '@/config/apiUrls';
import { errorToast } from '@/utils/toastUtils';

export const getAllSubjects = async () => {
  try {
    const url = (apiUrls.getAllSubjects as () => string)();
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const getSubjectById = async (subjectId: string) => {
  try {
    const url = (apiUrls.getSubjectById as (subjectId: string) => string)(subjectId);
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const addSubject = async (newSubject: SubjectType) => {
  try {
    const url = (apiUrls.addSubject as () => string)();
    return await axios.post(url, newSubject);
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const editSubject = async (subjectIdent: string, editedSubject: SubjectType) => {
  try {
    const url = (apiUrls.editSubject as (subjectId: string) => string)(subjectIdent);
    return await axios.put(url, editedSubject);
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const importSubject = async (subjectIdent: string, file: any) => {
  const config = {
    headers: {
      'Content-Type': 'application/octet-stream;charset=UTF-8',
      'Content-Disposition': 'attachment; filename=' + file.name,
    },
  };
  try {
    const url = (apiUrls.importSubject as (subjectId: string) => string)(subjectIdent);
    return await axios.post(url, file, config);
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const exportSubject = async (subjectIdent: string) => {
  try {
    const url = (apiUrls.exportSubject as (subjectId: string) => string)(subjectIdent);
    return await axios.get(url, { responseType: 'blob' }).then((response) => {
      const filename = response.headers['content-disposition'].split('filename=')[1];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      return response;
    });
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};
